module.exports = __webpack_public_path__ + "img/12.690117a.jpg";